// extracted by mini-css-extract-plugin
export var item = "NumbersList-module--item--U65rc";
export var list = "NumbersList-module--list--JgTrL";